import React from 'react'
import Main from '../Main/Main'
import About from '../About/About'
import Team from '../Team/Team'
import ProductsandServices from '../ProductandServices/ProductsandServices'
import Contact from '../Contact/Contact'

const FirstSet = () => {
  return (
    <div>

    <Main/>
     <About/>
     <Team/>
     <ProductsandServices/>
     <Contact/>
      
    </div>
  )
}

export default FirstSet
